import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import useGenerateDeliveryNotePdf from "./useGenerateDeliveryNotePdf";
import usePrepareGenerateDeliveryNotePdf from "./usePrepareGenerateDeliveryNotePdf";
import { GenerateDeliveryNotePdfActionContext } from "./GenerateDeliveryNotePdfActionContext";
import { Form } from "react-bootstrap";

function useGenerateDeliveryNotePdfAction(modelConfig: any, index: any): any {
  const prepare = usePrepareGenerateDeliveryNotePdf();
  const prepareFunction = (deliveryNoteId: any) => prepare(deliveryNoteId);

  const onSuccess = () => {
    setShowModal(false);
    index();
  };

  const run = useGenerateDeliveryNotePdf();
  const runFunction = (deliveryNoteId: any) => run(deliveryNoteId, onSuccess);

  const contextInstance = useContext(GenerateDeliveryNotePdfActionContext);
  const { setShowModal, deliveryNoteId, sendToCustomer, setSendToCustomer } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "generate-delivery-note-pdf",
  onSubmit: () => deliveryNoteId != null && runFunction(deliveryNoteId),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <div>
        <p>{t("are_you_sure_you_want_to_generate_the_delivery_note_pdf_for_this_booking?")}</p>
        <Form.Group className="mt-3">
          <Form.Check 
            type="checkbox"
            id="send-to-customer-checkbox-delivery-note"
            label={t("send_to_customer")}
            checked={sendToCustomer}
            onChange={(e) => setSendToCustomer(e.target.checked)}
          />
        </Form.Group>
      </div>
    </CrudModuleFactoryModal>
  );

  return {
    prepareGenerateDeliveryNotePdfFunction: prepareFunction,
    actionTemplate,
  };
}

export default useGenerateDeliveryNotePdfAction;
